'use strict';
module.exports = function (val) {
	if (val === null || val === undefined) {
		return [];
	}

	return Array.isArray(val) ? val : [val];
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/arrify/index.js
// module id = 819
// module chunks = 0